import React from 'react';

import { Banner } from '../../components/Banner';

class RefreshBanner extends React.PureComponent {

    render() {
        return <Banner message = {
          "New Booking Updates!"
        }
        cta = {
          "Click to refresh this page"
        }
        description = {
          "Make sure all your changes are saved before refreshing"
        }
        style = {
          {
            position: 'sticky',
            top: '0px'
          }
        }
        onClick = {
          () => window.location.reload()
        }
        />
    }
}

export default RefreshBanner;